import { useQueryClient } from '@tanstack/react-query'

export const useQueryClientSingleton = () => {
  return useQueryClient()
}
